var map = {
	"./english.json": [
		22,
		22
	],
	"./french.json": [
		878,
		878
	],
	"./german.json": [
		496,
		496
	],
	"./italian.json": [
		254,
		254
	],
	"./spanish.json": [
		630,
		630
	],
	"./turkish.json": [
		302,
		302
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 399;
module.exports = webpackAsyncContext;